import styled from 'styled-components';

// Mesmo visual da faixa de atraso (DelayRangeFilter), ao lado dela.
export const FilterBar = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

export const FilterLabel = styled.span.attrs({})`
  font-size: 12px;
  text-transform: uppercase;
  color: #718096;
  white-space: nowrap;
`;
